import styled from 'styled-components'

import zIndex from '../../../utils/zIndexScale'

export const Wrapper = styled.div`
  position: relative;
  background: ${({ theme }) => theme.exchangeSecondBg};
  flex: 1 1 auto;
  flex-grow: ${({ flexGrow }) => flexGrow};
  @media (min-width: 320px) and (max-width: 623px) {
    height: 450px;
  }
`

export const TradePairHD = styled.div`
  height: 20px;
  display: flex;
  flex-direction: row;
  padding: 5px;
  box-shadow: ${({ theme }) => theme.exchangeHeadShadow};
  position: relative;
  z-index: ${zIndex.tradePair};
`

export const TradePairInner = styled.div`
  transition: transform 0.2s ease;
  display: flex;
  user-select: none;
`

export const TradePairItem = styled.div`
  padding: 0 8px;
  height: 22px;
  line-height: 23px;
  font-size: 12px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 2px;
  color: ${({ theme }) => theme.exchangeTabNotSelectedColor};
  position: relative;
  transition: color 150ms, background 150ms;
  &:hover {
    background: ${({ theme }) => theme.exchangeTabSelectedBg};
    color: ${({ theme }) => theme.exchangeTabSelectedColor};
  }
  ${({ hasDropdown }) =>
    hasDropdown
      ? `
    &:after {

    }
  `
      : ''}
  ${({ hasDropdown, hide }) =>
    hasDropdown && !hide
      ? `
    &:after {
      transform: rotate(180deg);
    }
  `
      : ''}
`

export const SelectedTradePairItem = styled(TradePairItem)`
  background: ${({ theme }) => theme.exchangeTabSelectedBg};
  color: ${({ theme }) => theme.exchangeTabSelectedColor};

  ::after {
    content: ${({ theme }) => theme.exchangeTabSelectedContent};
    display: block;
    width: 16px;
    height: 2px;
    border-radius: 3px;
    background: #4653c8;
    position: relative;
    left: calc(50% - ${16 / 2}px);
  }
`

export const TradePairText = styled.div`
  text-align: left;
  width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  box-sizing: border-box;
  user-select: none;
`

export const FavoriteButton = styled.span`
  margin-right: 5px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 120%;
    height: 120%;
  }
`

export const TradePairContent = styled.div`
  overflow: auto;
  position: absolute;
  width: 100%;
  top: 60px;
  bottom: 0;
`

export const PriceAlign = styled.div`
  text-align: right;
  max-width: 90px;
  overflow: hidden;
`

export const Volume = styled.div`
  text-align: right;
`
